module.exports = "<p>\n  service-error works!\n</p>\n"